import {Scalars} from 'graphql-api'
import {createActionCreators, ImmerReducer} from 'immer-reducer'
import {select_jobs_permissibleForRescheduling, select_rescheduleJobs_allSelected} from 'redux/jobs/selectors'
import defaultJobsState, {JobsStateType, RescheduleJobCandidatesType} from './state'

class RescheduleJobs extends ImmerReducer<JobsStateType> {
  permissibleApplied(rescheduleJobCandidates: RescheduleJobCandidatesType) {
    this.draftState.rescheduleJobs.permissible = rescheduleJobCandidates
  }
  jobSelected(jobId: Scalars['UUID']) {
    this.draftState.rescheduleJobs.selected[jobId] = this.draftState.rescheduleJobs.permissible[jobId]
  }
  jobDeselected(jobId: Scalars['UUID']) {
    delete this.draftState.rescheduleJobs.selected[jobId]
  }
  allJobsSelected(flag) {
    if(flag) {
      this.draftState.rescheduleJobs.selected = this.state.rescheduleJobs.permissible
    } else {
      this.draftState.rescheduleJobs.selected = defaultJobsState.rescheduleJobs.selected
    }
  }
  rescheduleJobsReset() {
    this.draftState.rescheduleJobs.permissible = defaultJobsState.rescheduleJobs.permissible
    this.draftState.rescheduleJobs.selected = defaultJobsState.rescheduleJobs.selected
  }
}

export const setJobsPermissibleForRescheduling = () => function(dispatch, getState) {
  const jobsPermissibleForRescheduling = select_jobs_permissibleForRescheduling(getState())
  dispatch(RescheduleJobsAC.permissibleApplied(jobsPermissibleForRescheduling))
}

export const toggleAllPermissibleJobsForRescheduling = () => (dispatch, getState) => {
  const is = select_rescheduleJobs_allSelected(getState())
  dispatch(RescheduleJobsAC.allJobsSelected(!is))
}

export const RescheduleJobsAC = createActionCreators(RescheduleJobs)

export default RescheduleJobs
